/**
 * Collection Adventures – tab panels
 */
(function () {
  'use strict';

  function initTabs(root) {
    const tabs = root.querySelectorAll('[data-cadr-tab]');
    const panels = root.querySelectorAll('[data-cadr-panel]');
    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = tab.dataset.tabIndex;

        tabs.forEach((t) => {
          const active = t.dataset.tabIndex === index;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const active = panel.dataset.tabIndex === index;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });
  }

  function initSection(sectionRoot) {
    const root = sectionRoot.querySelector('[data-collection-adventures]');
    if (!root || root.dataset.cadrReady === 'true') return;
    root.dataset.cadrReady = 'true';
    initTabs(root);
  }

  function initAll() {
    document.querySelectorAll('.collection-adventures-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section.classList.contains('collection-adventures-section')) {
      const root = section.querySelector('[data-collection-adventures]');
      if (root) root.dataset.cadrReady = 'false';
      initSection(section);
    }
  });
})();
